import { AnimationOptions } from "types/animationScreen";
import CoinPurchaseComplete from './CoinPurchaseComplete';
import FreeCoinReward from './FreeCoinReward';
import PrimeBJRestriction from "./PrimeBJRestriction";

const ANIMATION_SCREENS: Record<string, { content: React.ComponentType; options?: AnimationOptions }> = {
  CoinPurchaseComplete: {
    content: CoinPurchaseComplete,
    options: { background: 'linear-gradient(180deg, rgba(16, 16, 28, 0.00) 0%, #10101C 100%)', loop: false, duration: 300 },
  },
  FreeCoinReward: {
    content: FreeCoinReward,
    options: { background: 'linear-gradient(180deg, rgba(16, 16, 28, 0.00) 0%, #10101C 100%)', loop: false, duration: 300 },
  },
  PrimeBJRestriction: {
    content: PrimeBJRestriction,
    options: { background: '#10101C', loop: false, duration: 300 },
  },
};

export default ANIMATION_SCREENS;